<template>
  <v-layout column>
    <div class="pr-header pr-header__background text-xs-center">
      <div class="header-title">{{ $t('Best Performing Inverter') }}</div>
      <div class="header-info">{{ $t('trend compared to prior month\'s PR') }}</div>
    </div>
    <div class="pr-overall__card">
      <div v-if="Object.keys(header).length">
        <div class="sub-header header-layout" :style="{
          justifyContent: 'center'
        }">
          <div>{{ $t('Highest ranked Inverters') }}</div>
          <div :style="{ paddingLeft: '10px', paddingTop: '3px' }">
            <v-tooltip color="bg" bottom>
              <template v-slot:activator="{ on }">
                  <v-icon v-on="on">info</v-icon>
              </template>
              <div id="hover__card" class="tool-tip__color">
                <div class="text-xs-center"><span
                    :style="{ fontSize: '1.5em', fontWeight: 'bold' }">
                    {{ $t('Best inverters') }}
                  </span><span>({{ $t('Present & Last month') }})</span></div>
                <v-layout row justify-space-between>
                  <div :style="{ display: 'flex', flexDirection: 'column' }">
                    <h4 class="text-xs-center">{{ $t('PRESENT') }}</h4>
                    <div v-for="(h, index) in header.present" :key="index">
                      {{ h }}</div>
                  </div>
                  <div :style="{ display: 'flex', flexDirection: 'column' }">
                    <h4 class="text-xs-center">{{ $t('LAST') }}</h4>
                    <div v-for="(h, index) in header.last" :key="index">
                      {{ h }}</div>
                  </div>
                </v-layout>
              </div>
            </v-tooltip>
          </div>
        </div>
        <div>
          <v-layout row :style="{ paddingTop: '4vh' }">
            <v-flex xs2></v-flex>
            <v-flex xs5 class="pr-summary__text">
              <v-layout column :style="{
                rowGap: '7px',
                paddingTop: '10px'
              }">
                <v-flex>
                  {{ $t('Trend compared to prior month (%)') }}
                </v-flex>
                <v-flex>
                  {{ $t('Current month\'s PR (%)') }}
                </v-flex>
                <v-flex>
                  {{ $t('Prior month\'s PR (%)') }}
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs1></v-flex>
            <v-flex xs2 class="text-xs-center pr-summary__value">
              <v-layout row wrap>
                <v-flex :class="header.flow == 'up' ? 'success--text' : 'error--text'">
                  {{ header.trend }}
                    <v-icon medium>{{ header.flow == 'up' ? 'arrow_upward' : 'arrow_downward' }}</v-icon>
                </v-flex>
                <v-flex :class="header['current-pr'] == null || header['current-pr'] == 'No Data' ? 'error--text' : 'number--text'">
                  {{ header['current-pr'] }}
                </v-flex>
                <v-flex :class="header['last-pr'] == null || header['last-pr'] == 'No Data' ? 'error--text' : 'number--text'">
                  {{ header['last-pr'] }}
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs1>
            </v-flex>
          </v-layout>
        </div>
      </div>
      <div v-else class="image">
        <img src="../../assets/informationSet.svg" alt="no data" height="150px" width="200px">
        <div class="no_data">
          <h4>{{ $t('PR\'S NOT CONFIGURED') }}</h4>
        </div>
      </div>
    </div>
  </v-layout>
</template>

<script>
export default {
  props: {
    header: {
      type: Object,
      default: function() {
        return {}
      }
    }
  }
}
</script>

<style scoped>
.pr-header {
  height: 58px;
  border-radius: 5px 5px 0px 0px;
}

.theme--dark .pr-header__background {
  background-color: var(--v-primary-base);
}

.theme--light .pr-header__background {
  background-color: var(--v-grey-base);
}

.header-title {
  font-size: 18px;
  font-weight: 700;
  line-height: 19px;
  padding-top: 10px;
}

.header-info {
  font-size: 12px;
  font-weight: 400;
  line-height: 15px;
  padding-top: 3px;
}

.pr-overall__card {
  height: 212px;
  border-radius: 0px 0px 5px 5px;
  background-color: var(--v-primary-base);
}

.sub-header {
  font-size: 16px;
  font-weight: 400;
  line-height: 19px;
  padding-top: 15px;
}

.header-layout {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.pr-summary__text {
  font-weight: 400;
  font-size: 14px;
  line-height: 17px;
}

.pr-summary__value {
  font-weight: 500;
  font-size: 22px;
  line-height: 27px;
}

#hover__card {
  width: 320px;
  padding: 10px;
}

.image {
  padding: 0.65rem 5.5rem;
}

.no_data {
  text-align: center;
  padding-top: 5px;
}

</style>
